import { mapState, mapActions } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import ValidateMixin from "@/mixins/ValidateMixin.vue";
import AppForm from "@/components/AppForm.vue";
import AppInputV2 from "@/components/AppInputV2.vue";
import AppButton from "@/components/AppButton.vue";
import AppIcon from "@/components/AppIcon";
import TheWrapperPublicV2 from "@/components/TheWrapperPublicV2.vue";
import StrokedChevronLeftIcon from "@/components/icons/StrokedChevronLeftIcon.vue";
import RecoverySuccess from "@/components/RecoverySuccess.vue";
import NewLogoWithOmny from "@/components/brand_elements/NewLogoWithOmny.vue";
export default {
  name: "ResetPasswordPage",
  mixins: [ValidateMixin],
  components: {
    AppForm,
    AppInputV2,
    AppButton,
    AppIcon,
    TheWrapperPublicV2,
    StrokedChevronLeftIcon,
    RecoverySuccess,
    NewLogoWithOmny
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      form: {
        password: "",
        confirm_password: ""
      },
      loading: false,
      showSuccessMessage: false
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token
    })
  },
  methods: {
    ...mapActions(["resetPassword"]),
    async onSubmit() {
      // Check if password and confirm password are the same
      if (this.form.password !== this.form.confirm_password) {
        window.$bus.trigger("showDanger", {
          visible: true,
          message: "Password and confirm password are not the same."
        });
        return;
      }
      const isValid = await this.mValidate();
      if (!isValid) return;
      this.loading = true;
      await this.resetPassword(this.form);
      this.loading = false;
      this.showSuccessMessage = true;
    },
    loginPage() {
      this.$router.push("/login");
    }
  }
};